import {
  faAngleLeft,
  faAngleRight,
} from '@fortawesome/pro-regular-svg-icons'
import { Button } from '@karnov/kui-react'

import { NavigationDirection } from './types'

import type { FC } from 'react'

type Props = {
  navigationDirection: NavigationDirection
  onClick: (navigationDirection: NavigationDirection) => void
}

export const NavigationArrow: FC<Props> = ({
  navigationDirection,
  onClick,
}) => {
  const handleClick = () => {
    onClick(navigationDirection)
  }

  return (
    <Button
      icon={navigationDirection === 'previous' ? faAngleLeft : faAngleRight}
      onClick={handleClick}
      variant="plain"
    />
  )
}
